import request from '@/utils/request'

export const getGovList = ({ page, size, keywords: orgName }) => {
  return request({
    url: `/upms/org/gov/${page}/${size}`,
    params: {
      orgName
    }
  })
}

export const putGovAdd = (data) => {
  return request({
    method: 'put',
    url: '/upms/org/gov',
    data
  })
}

export const postGovEdit = (data) => {
  return request({
    method: 'post',
    url: '/upms/org/gov',
    data
  })
}

export const getGovDetail = (id) => {
  return request({
    url: `/upms/org/gov/${id}`
  })
}

export const deleteGovDel = (id) => {
  return request({
    method: 'delete',
    url: `/upms/org/${id}`
  })
}

export const delGovList = (data) => {
  return request({
    method: 'delete',
    url: '/upms/org/all',
    data
  })
}

// 机构权限
export const putGovResourceAdd = (data) => {
  return request({
    method: 'put',
    url: '/upms/org/resource',
    data
  })
}

export const getGovResource = (orgId) => {
  return request({
    url: `/upms/org/resource/${orgId}`
  })
}
